import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'

Alpine.plugin(focus)
window.Alpine = Alpine

Alpine.start()

//import './components/modal';
import './components/header';
import './components/form';
import './components/swiper';
import './components/cars';